module.exports = __webpack_public_path__ + "static/media/whatsapp_circle_icon.b17d294f.svg";